import React, { useMemo } from "react";
import { LayerConfig, LayerHook, LayerHookBuilder } from "./types";

export type ContourLayerConfig = LayerConfig;

import ContourLayer, { id as layerId } from "../layers/contourLines";

const useContourHook: LayerHookBuilder<ContourLayerConfig> = ({ config }) => {
  return useMemo<LayerHook>(() => {
    return {
      interactiveLayerIds: [layerId],
      render: () => <ContourLayer key={"contour"} />,
    };
  }, [config]);
};

export default useContourHook;
